<template>
    <component
        ref="dropdown"
        class="flex items-center fit-content"
        :is="quickLook ? 'vx-dropdown' : 'div'"
    >
        <!-- style="cursor: pointer"
    :justify="justifyQuickLook"
    :align="alignQuickLook"
    @click="navigate" -->
        <slot>
            <vx-chip class="chip" v-bind="$attrs">
                <slot>
                    <span class="whitespace-nowrap">
                        {{ practice.name }}
                    </span>
                </slot>
                <template slot="append">
                    <slot name="append"></slot>
                </template>
            </vx-chip>
            <!-- <template v-if="quickLook" slot="menu">
                <vx-card
                    :title="practice.name"
                    no-shadow
                    no-radius
                    style="background-color: transparent"
                >
                    <staff-contact-info :staff="staff_x" hide-image />
                </vx-card>
            </template> -->
        </slot>
    </component>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'practice-chip',
    components: {},
    props: {
        practice: {
            type: [Object, String],
            default: () => {}
        },
        hidePhoto: {
            type: Boolean
        },
        quickLook: {
            type: [Boolean, String]
        },
        alignQuickLook: {
            type: String,
            default: 'top'
        },
        justifyQuickLook: {
            type: String,
            default: 'center'
        },
        preventNavigation: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            //getPracticeById: 'admin/getPracticeById'
        })
        // fullName() {
        //     return this.loading ? 'Loading...' : `${this.practice_x}`
        // },
        // practice_x() {
        //     if (!this.practice) {
        //         return {}
        //     }
        //     if (typeof this.practice === 'object') {
        //         return this.practice
        //     }
        //     return // this.getPracticeById(this.practice)
        // }
    },
    methods: {
        async navigate() {
            if (this.preventNavigation) {
                return
            }
            await this.$router.push({
                name: 'practice-directory',
                params: {
                    practiceId: this.practice.id
                }
            })
        }
    },
    mounted() {}
}
</script>
